/**
 * Mock User Data
 * 
 * Centralized mock data for users and authentication
 */

import { User } from '../../types'

export const mockUsers: User[] = [
  {
    id: '1',
    email: 'user@example.com',
    name: 'John Doe',
    role: 'user',
    credits: 100,
    balance: 0,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    profile: {
      avatar: '/avatars/user1.jpg',
      bio: 'AI enthusiast and chatbot creator',
      website: 'https://johndoe.com',
      location: 'New York, NY'
    }
  },
  {
    id: '2',
    email: 'creator@example.com',
    name: 'Jane Creator',
    role: 'creator',
    credits: 500,
    balance: 250.50,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    profile: {
      avatar: '/avatars/creator1.jpg',
      bio: 'Professional chatbot developer',
      website: 'https://janecreator.com',
      location: 'San Francisco, CA'
    }
  },
  {
    id: '3',
    email: 'admin@example.com',
    name: 'Admin User',
    role: 'admin',
    credits: 1000,
    balance: 0,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    profile: {
      avatar: '/avatars/admin1.jpg',
      bio: 'Platform administrator',
      website: 'https://admin.com',
      location: 'Austin, TX'
    }
  }
]

export const getMockUser = (id: string): User | undefined => {
  return mockUsers.find(user => user.id === id)
}

export const getMockUserByEmail = (email: string): User | undefined => {
  return mockUsers.find(user => user.email === email)
} 